import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { LiteralsTranslationService } from '@uipath/workflow-web-viewer';
var NugetViewerTranslationService = /** @class */ (function (_super) {
    tslib_1.__extends(NugetViewerTranslationService, _super);
    function NugetViewerTranslationService(translateService) {
        var _this = _super.call(this) || this;
        _this.translateService = translateService;
        _this.getValue = function (literalKey) {
            var value = _this.translateService.instant(literalKey);
            if (value === literalKey) {
                return _super.prototype.getValue.call(_this, literalKey);
            }
            return value;
        };
        return _this;
    }
    return NugetViewerTranslationService;
}(LiteralsTranslationService));
export { NugetViewerTranslationService };
